import { useAtomValue } from 'jotai';

import { FEATURE_FLAGS_UNAVAILABLE, featureFlagsAtom } from '@/atoms/featureFlags';

export const useFeatureFlag = () => {
    const backendFeatureFlags = useAtomValue(featureFlagsAtom);
    const areFeatureFlagsKnown = Array.isArray(backendFeatureFlags);

    const isFeatureEnabled = (feature: string): boolean =>
        areFeatureFlagsKnown &&
        backendFeatureFlags.some((flag) => flag.isEnabled && flag.name === feature);

    return {
        isFeatureEnabled,
        /**
         * Whether the backend's configuration has answered. Until it has, every flag reads as
         * disabled, which is an absence of knowledge and not a decision: callers that would hide
         * something must wait for this rather than act on the interim `false`.
         */
        areFeatureFlagsKnown,
        /**
         * Whether that answer will not come: the request failed. A flag reading `false` then says
         * nothing about the organization, so callers must offer a retry rather than a verdict.
         */
        areFeatureFlagsUnavailable: backendFeatureFlags === FEATURE_FLAGS_UNAVAILABLE,
    };
};
